import { useMemo } from 'react'
import toast from 'react-hot-toast'
import { TwoFactorPanel, type MfaSelfApi } from '@twasta/page-runtime/shell'
import {
  getMfaStatus, startTotpSetup, confirmTotpSetup, regenerateRecoveryCodes, disableMfa,
} from '@/api/users'

/**
 * Settings → Account → Two-factor sign-in (roadmap item 1, phase 1). The panel
 * is the shared page-runtime one project users see in My account; this card
 * is only the builder's frame and its calls (/api/users/mfa/*).
 */
export default function TwoFactorCard() {
  const api = useMemo<MfaSelfApi>(() => ({
    status: getMfaStatus,
    totpStart: startTotpSetup,
    totpConfirm: confirmTotpSetup,
    recoveryCodes: regenerateRecoveryCodes,
    disable: disableMfa,
  }), [])
  const notify = useMemo(() => ({ success: (m: string) => toast.success(m), error: (m: string) => toast.error(m) }), [])

  return (
    <section data-tw-mfa-card="" style={{
      background: 'var(--color-bg-secondary)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-lg)',
      padding: '1.5rem',
      marginBottom: '1.5rem',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: '1rem' }}>
        <span className="material-icons" style={{ fontSize: 21, color: 'var(--color-accent)' }}>phonelink_lock</span>
        <h2 style={{ fontSize: '1.125rem', fontWeight: 600 }}>Two-factor sign-in</h2>
      </div>
      <div style={{ maxWidth: 460 }}>
        <TwoFactorPanel api={api} notify={notify} />
      </div>
    </section>
  )
}
